import { z } from "zod";

import { richTextSchema } from "./rich-text";

const baseFormFieldsSchema = z.object({
  label: z.string(),
  hideLabel: z.boolean().nullish(),
  name: z.string(),
  required: z.boolean(),
  placeholder: z.string().nullish(),
});

export const formFieldsSchema = [
  baseFormFieldsSchema.merge(
    z.object({
      _type: z.literal("textField"),
      type: z.enum(["text", "email", "number", "url", "tel"]),
    })
  ),
  baseFormFieldsSchema.omit({ placeholder: true }).merge(
    z.object({
      _type: z.literal("checkbox"),
      defaultValue: z.boolean().nullish(),
    })
  ),
  baseFormFieldsSchema.merge(
    z.object({
      _type: z.literal("dropdown"),
      options: z.array(
        z.object({ label: z.string(), value: z.string().nullish() })
      ),
    })
  ),
] as const;

export const formSchema = z.object({
  _type: z.literal("form"),
  fields: z.array(
    z.discriminatedUnion("_type", [
      ...formFieldsSchema,
      z.object({
        _type: z.literal("fieldset"),
        legend: z.string(),
        hideLegend: z.boolean().nullish(),
        fields: z.array(z.discriminatedUnion("_type", [...formFieldsSchema])),
        layout: z.enum(["grid", "stack"]),
      }),
    ])
  ),
  name: z.string(),
  id: z.string(),
  guid: z.string(),
  adrollSegmentId: z.string().nullish(),
  disclaimerText: richTextSchema.nullish(),
  submitButtonText: z.string(),
  successState: z.object({
    // TODO - move title into description
    title: z.string().optional(),
    description: richTextSchema,
    /** Optional next step offered once the form has been submitted. */
    cta: z
      .object({
        label: z.string(),
        href: z.string(),
        /** Routes through ExternalLink, which app.wayflyer.com links need. */
        external: z.boolean().optional(),
      })
      .optional(),
  }),
  background: z.enum(["light", "gray", "dark"]).optional(),
});
